import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import IntegrationBreadcrumb from 'components/Integration/components/IntegrationBreadcrumb'
import { api } from 'app/modules/eloqua/api'
import { fetchAttributes } from 'app/modules/endUser/attribute/actions'
import { filteredProperties } from 'app/modules/endUser/attribute/selectors'
import AttributeMapper from '../../components/AttributeMapper'
import { EloquaMapping } from 'app/modules/eloqua/models'
import withNotifications from 'components/shared/notifications'
import EloquaCdoSelect from './EloquaCdoSelect'

import './style.styl'

const HELP_DOC_URL = "https://help.drift.com/article/eloqua-&-drift/"
const integrationName = "Eloqua"
const getSuccessMessage = (integrationName) => `You successfully updated your ${integrationName} App!`
const getErrorMessage = (integrationName) => `There was an error when updating your ${integrationName} App!`

class EloquaAttributeMappingCdo extends Component {
  constructor(props){
    super(props)
    this.state = {
      mappings: [],
      showAttributeMapper: false,
      cdoMappings: [],
      eloquaCdoFields: [],
      specialFields: [
        { "label" : "Conversation Id", "type" : "STRING", value: "_integrations_conversation_id" },
        { "label" : "Conversation Transcript", "type" : "STRING", value: "_integrations_conversation_transcript" },
        { "label" : "Conversation URL", "type" : "STRING", value: "_integrations_conversation_url" },
        { "label" : "Lead Owner", "type" : "STRING", value: "_integrations_lead_owner" }
      ]
    }
  }

  componentDidMount() {
    this.props.actions.fetchDriftProperties()
    this.getEloquaCdoMappings()
    this.getEloquaCdoFields()
  }

  getEloquaCdoFields = async () => {
    try {
      const eloquaCdoFields = await api.fetchEloquaCdoFields()

      this.setState({
        eloquaCdoFields: eloquaCdoFields.fields
      })
    } catch(e) {
      console.warn(e)
    }
  }

  patchEloquaCdoMappings = (mappings) => {
    const { notifications } = this.props
    const payload = { integrationAttributeMappings: { mappings: mappings }}

    try {
      api.patchEloquaCdoConfig(payload)
      this.setState({ cdoMappings: mappings })
      notifications.success(getSuccessMessage(integrationName))
    } catch(e) {
      console.warn(e)
      notifications.error(getErrorMessage(integrationName))
    }
  }

  getEloquaCdoMappings = async () => {
    let eloquaCdoConfig

    try {
      eloquaCdoConfig = await api.fetchEloquaCdoConfig()
    } catch(e) {
      console.warn(e)
    }

    const cdoMappings = eloquaCdoConfig.integrationAttributeMappings.mappings

    if (cdoMappings != undefined) {
      this.setState({
        cdoMappings: cdoMappings
      })
    }
  }

  toggleAttributeMapper = async (shouldShow) => {
    this.setState({ showAttributeMapper: shouldShow })
  }

  render() {
    const { driftProperties } = this.props
    const { cdoMappings, eloquaCdoFields, specialFields, showAttributeMapper } = this.state

    return (
      <div className="eloqua-cdo-mapping common-integration-page-layout">
        <IntegrationBreadcrumb
          backLinkText="Eloqua Integration"
          backLinkUrl={`/settings/setup/eloqua`}
        />
        <header className="eloqua-cdo-mapping-header">
          <h2 className="integration-header">Mapped Eloqua CDO Attributes</h2>
          <p> Map which fields you want to configure to your Eloqua CDO. These Drift attributes will be added to the selected Eloqua CDO. 
            <a href={HELP_DOC_URL}> Learn More</a>
          </p>
          <h3><b>Eloqua CDO</b></h3>
          <EloquaCdoSelect 
            refreshEloquaFields={this.getEloquaCdoFields}
            toggleAttributeMapper={this.toggleAttributeMapper} />
        </header>

        { showAttributeMapper &&
          <AttributeMapper
            integrationName="Eloqua"
            mappings={cdoMappings}
            driftAttributes={specialFields.concat(driftProperties)}
            integrationAttributes={eloquaCdoFields}
            mappingModel={EloquaMapping}
            patchMappings={this.patchEloquaCdoMappings}
            patchLoading={false}
            allowAttributeDefaults={true}
            allowAttributeOverwrites={false} />
        }
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    driftProperties: filteredProperties(state),
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({
      fetchDriftProperties: fetchAttributes,
    }, dispatch)
  }
}

export default withNotifications(connect(mapStateToProps, mapDispatchToProps)(EloquaAttributeMappingCdo))



// WEBPACK FOOTER //
// ./src/scripts/components/Integration/pages/EloquaAttributeMappingCdo/index.js